var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showModalVisualizarProcesso && _vm.idProcesso !== null
        ? _c("app-modal-visualizar-completo", {
            attrs: {
              idProcesso: _vm.idProcesso,
              protocolo: _vm.protocolo,
              numeroProcesso: _vm.numeroProcesso,
              tipo: _vm.tipoProcesso
            },
            on: {
              closeModal: function($event) {
                _vm.showModalVisualizarProcesso = false
              }
            }
          })
        : _vm._e(),
      _vm.showModalRetificacao
        ? _c("app-modal-cancelar-retificacao", {
            attrs: {
              idProcesso: _vm.idProcesso,
              numeroProcesso: _vm.numeroProcesso,
              setor: _vm.setor
            },
            on: { closeModal: _vm.closeRetificacao }
          })
        : _vm._e(),
      _vm.showModalResponsavel
        ? _c("modal-trocar-responsavel", {
            attrs: { processo: _vm.processoTrocado },
            on: {
              closeModal: _vm.FECHAR_MODAL_RESPONSAVEL,
              refresh: _vm.refresh
            }
          })
        : _vm._e(),
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c("filtro", {
            attrs: {
              showOs: true,
              showMunicipios: true,
              configuracaoFiltro: _vm.configuracaoFiltro,
              filtroRapido: _vm.filtroRapido
            },
            on: { pesquisar: _vm.pesquisar, limpar: _vm.clear }
          })
        ],
        1
      ),
      _c("app-modal-selecionar-modelo-extrato-sentenca", {
        attrs: {
          titulo: "Extrato de sentença",
          showModal: _vm.showModalModeloDespacho,
          processosSelecionados: _vm.processosSelecionados
        },
        on: { closeModal: _vm.fecharModalModeloDespacho }
      }),
      _c("app-listagem", {
        attrs: {
          "has-refresh-button": true,
          showButtonOrdemServico: false,
          showButtonAssinatura: false,
          "has-expansivel": false,
          "json-headers": _vm.colunas,
          "json-data": _vm.items,
          totalElements: _vm.totalElements,
          pagina: _vm.filtro.pagina,
          hasFiltroRapido: true,
          filtro: _vm.filtro,
          infoPrazos: _vm.infoPrazos
        },
        on: {
          atualizarFiltro: _vm.atualizarFiltro,
          updateListagem: _vm.refresh,
          changePage: _vm.changePage,
          sort: _vm.sort,
          executar: _vm.executar,
          selected: false,
          selectItem: _vm.selecionarProcessos
        }
      }),
      _vm.isEstadoBA()
        ? _c(
            "el-row",
            { staticClass: "row-style" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: !_vm.processosSelecionados.length,
                    type: "success",
                    size: "small"
                  },
                  on: {
                    click: function($event) {
                      return _vm.criarExtratoSentenca()
                    }
                  }
                },
                [_c("b", [_vm._v("Criar Extrato de Sentença")])]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f33bc1ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f33bc1ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/listagem/CaixaPublicacaoListagem.vue
// module id = null
// module chunks = 